const adminNavbarI18n = {
  "fr": {
    "links": {
      "products": "Produits",
      "transactions": "Transactions",
      "users": "Utilisateurs",
      "logs": "Logs"
    },
    "logout": "Déconnexion"
  },
  "en": {
    "links": {
      "products": "Products",
      "transactions": "Transactions",
      "users": "Users",
      "logs": "Logs"
    },
    "logout": "Log out"
  },
  "pl": {
    "links": {
      "products": "Produkty",
      "transactions": "Transakcje",
      "users": "Użytkownicy",
      "logs": "Logi"
    },
    "logout": "Wyloguj"
  },
  "es": {
    "links": {
      "products": "Productos",
      "transactions": "Transacciones",
      "users": "Usuarios",
      "logs": "Registros"
    },
    "logout": "Cerrar sesión"
  },
  "it": {
    "links": {
      "products": "Prodotti",
      "transactions": "Transazioni",
      "users": "Utenti",
      "logs": "Logs"
    },
    "logout": "Accedi"
  },
  "de": {
    "links": {
      "products": "Produkte",
      "transactions": "Transaktionen",
      "users": "Nutzer",
      "logs": "Protokolle"
    },
    "logout": "Abmelden"
  },
  "pt": {
    "links": {
      "products": "Produtos",
      "transactions": "Operações",
      "users": "Utilizadores",
      "logs": "Registos"
    },
    "logout": "Sair"
  },
  "cs": {
    "links": {
      "products": "Produkty",
      "transactions": "Transakce",
      "users": "Uživatelé",
      "logs": "Záznamy"
    },
    "logout": "Odhlásit se"
  },
  "nl": {
    "links": {
      "products": "Producten",
      "transactions": "Transacties",
      "users": "Gebruikers",
      "logs": "Logs"
    },
    "logout": "Afmelden"
  }
};

export default adminNavbarI18n;
